import type { ComponentProps } from 'react';
import { OwcRadio } from '@one/react';

export type PocRadioProps = ComponentProps<typeof OwcRadio>;

export const PocRadio: React.FC<PocRadioProps> = (props) => <OwcRadio {...props} />;
